import React from "react";
import api, { formatApiError } from "@/lib/api";
import { Activity } from "lucide-react";
import { useEffect, useState } from "react";
import FinanceReport from "@/components/FinanceReport";
import AdvisorReport from "@/components/AdvisorReport";
import { activityLabel } from "@/lib/activityLabels";

export default function Reports() {
  const [stats, setStats] = useState({});
  const [logs, setLogs] = useState([]);
  const [projects, setProjects] = useState([]);
  const [error, setError] = useState("");
  const [reload, setReload] = useState(0);

  useEffect(() => {
    let active = true;
    setError("");
    for (const [path, setter] of [["/dashboard/stats", setStats], ["/activity-log?limit=50", setLogs], ["/projects", setProjects]]) {
      api.get(path).then(({ data }) => { if (active) setter(data); })
        .catch(e => { if (active) setError(formatApiError(e)); });
    }
    return () => { active = false; };
  }, [reload]);

  return (
    <div className="space-y-6" data-testid="reports-page">
      <div>
        <h1 className="text-3xl font-bold text-slate-900 font-display">Raporlar &amp; Aktiviteler</h1>
      </div>

      <FinanceReport />
      {error && <div role="alert" className="text-sm text-red-700">{error} <button className="btn-secondary" onClick={() => setReload(v => v + 1)}>Tekrar dene</button></div>}
      <AdvisorReport />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="bg-white border border-slate-200 rounded-xl p-5">
          <div className="text-base font-semibold mb-3">Güncel Proje Stok Özeti</div>
          <ul className="divide-y divide-slate-100 text-sm">
            {projects.map((p) => (
              <li key={p.id} className="py-2 flex justify-between">
                <span className="text-slate-700">{p.name}</span>
                <span className="text-slate-500">{p.sold_units} / {p.total_units} satıldı</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="bg-white border border-slate-200 rounded-xl p-5">
          <div className="text-base font-semibold mb-3">Bölüm Durum Dağılımı</div>
          <ul className="space-y-2 text-sm">
            {Object.entries(stats.units || {}).map(([k, v]) => (
              <li key={k} className="flex justify-between">
                <span className="text-slate-700">{k}</span>
                <b>{v}</b>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="bg-white border border-slate-200 rounded-xl overflow-hidden">
        <div className="px-4 py-3 border-b border-slate-100 text-sm font-semibold flex items-center gap-2">
          <Activity className="w-4 h-4" /> Son İşlemler
        </div>
        <ul className="divide-y divide-slate-100 max-h-96 overflow-y-auto">
          {logs.map((l) => (
            <li key={l.id} className="px-4 py-3 text-sm flex items-center justify-between">
              <div>
                <div className="text-slate-900">{l.description}</div>
                <div className="text-xs text-slate-500">{l.user_name} • {activityLabel(l.action_type)}</div>
              </div>
              <div className="text-xs text-slate-400">{(l.created_at || "").slice(0, 19).replace("T", " ")}</div>
            </li>
          ))}
          {logs.length === 0 && <li className="px-4 py-8 text-sm text-slate-400 text-center">Aktivite kaydı yok</li>}
        </ul>
      </div>
    </div>
  );
}
